module.exports = __webpack_public_path__ + "img/roboto-v30-latin-300.991f795.svg";